import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    UpdateDigestSubscription as UpdateDigestSubscriptionMutation,
    UpdateDigestSubscriptionVariables,
    DigestSubscriptionUpdateInput,
    GetDigestConfiguration_digestConfiguration_subscription as DigestSubscription,
} from 'nutshell-graphql-types';

import UPDATE_DIGEST_SUBSCRIPTION from '../mutations/update-digest-subscription.graphql';
import GET_DIGEST_CONFIGURATION from '../queries/get-digest-configuration.graphql';

export const useUpdateDigestSubscription = (): {
    updateDigestSubscription: (
        arg1: DigestSubscriptionUpdateInput,
        arg2?: DigestSubscription | null | undefined
    ) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [updateDigestSubscription, {loading, error}] = useMutation<
        UpdateDigestSubscriptionMutation,
        UpdateDigestSubscriptionVariables
    >(UPDATE_DIGEST_SUBSCRIPTION);

    return {
        updateDigestSubscription: (
            input: DigestSubscriptionUpdateInput,
            subscription?: DigestSubscription | null
        ) => {
            let isActive = true;
            if (input.isActive != null) {
                isActive = input.isActive;
            } else if (subscription) {
                isActive = subscription.isActive;
            }

            let frequency = 'WEEKLY';
            if (input.frequency) {
                frequency = input.frequency;
            } else if (subscription) {
                frequency = subscription.frequency;
            }

            return updateDigestSubscription({
                variables: {input},
                optimisticResponse: {
                    __typename: 'Mutation',
                    digestSubscriptionUpdate: {
                        __typename: 'DigestConfiguration',
                        subscription: {
                            __typename: 'DigestSubscription',
                            id: 'temp',
                            digestType: input.digestType,
                            isActive,
                            // @ts-expect-error
                            frequency,
                        },
                        nextSendDate: null,
                    },
                },
                update: (proxy, {data}) => {
                    if (!data || !data.digestSubscriptionUpdate) {
                        return;
                    }

                    proxy.writeQuery({
                        query: GET_DIGEST_CONFIGURATION,
                        variables: {
                            digestType: input.digestType,
                        },
                        data: {
                            digestConfiguration: {
                                ...data.digestSubscriptionUpdate,
                            },
                        },
                    });
                },
            });
        },
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
